import React, { useState, useEffect, createContext } from 'react';
import { useLocation } from 'react-router';
import ErrorPage from '@/containers/ErrorPage/ErrorPage';

// @ts-ignore:next-line
const ErrorContext = createContext();

const defaultError = { code: '', message: '' };

const ErrorContextProvider = ({ children }): any => {
  const [error, setError] = useState(defaultError);
  const { pathname } = useLocation();

  useEffect(() => {
    setError(defaultError);
  }, [pathname]);

  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {error.code
        ? <ErrorPage {...error} />
        : children}
    </ErrorContext.Provider>
  );
};

export {
  ErrorContext,
  ErrorContextProvider,
};
